import React from "react";
import { Row, Col, Card, CardBody, Table, Button, Container } from "reactstrap";

import {
  ChapterLecturesStatsDto,
  LessonLectureStatsDto,
} from "../../interfaces";
import { useTranslation } from "react-i18next";
import { NavLink, useParams } from "react-router-dom";

import { TableSpinner } from "../../components";
import { NoResultFound } from "../../components/Common";
import { useGetChaptersLecturesStatsQuery } from "../../store/api/chapterApi";

export const LectureStatisticsPage = () => {
  //#region hooks
  const { subjectId } = useParams<any>();
  const { t, i18n } = useTranslation();
  //#endregion

  const {
    data: response,
    isLoading: loading,
    refetch,
  } = useGetChaptersLecturesStatsQuery(subjectId);

  return (
    <Container fluid>
      <Row className="mt-2 mb-4 align-items-center">
        <Col className="col-sm-auto">
          <div>
            <h4 className="mb-0">{t("lectures")}</h4>
          </div>
        </Col>
        <Col className="col-sm">
          <div className="d-flex justify-content-sm-end gap-2">
            <Button
              color="success"
              onClick={() => {
                refetch();
              }}
            >
              {t("refresh")}
            </Button>
          </div>
        </Col>
      </Row>

      {loading && <TableSpinner />}
      {!loading && (!response || response.length == 0) && <NoResultFound />}
      {!loading && response && response.length > 0 && (
        <div className="card-masonry">
          {response &&
            response.map((item: ChapterLecturesStatsDto, key: number) => (
              <div key={key}>
                <Card>
                  <CardBody>
                    <Row className="g-1 mb-3">
                      <div className="table-responsive">
                        <Table className="table-bordered table-nowrap align-middle mb-0">
                          <thead>
                            <tr style={{ border: "none" }}>
                              <th
                                colSpan={3}
                                scope="col"
                                className="text-left fs-16"
                                style={{ border: "none" }}
                              >
                                {i18n.language === "ar"
                                  ? item.name.ar
                                  : item.name.en}
                              </th>
                            </tr>
                          </thead>
                          <thead>
                            <tr>
                              <th scope="col" className="text-center"></th>
                              <th
                                scope="col"
                                className="text-center table-success"
                              >
                                {t("noOfLectures")}
                              </th>
                            </tr>
                          </thead>
                          <thead>
                            <tr>
                              <th scope="col" className="text-center">
                                {t("totalLectures")} &nbsp;
                                {i18n.language === "ar" ? (
                                  <i className="ri-arrow-left-line align-bottom"></i>
                                ) : (
                                  <i className="ri-arrow-right-line align-bottom"></i>
                                )}
                              </th>
                              <th
                                scope="col"
                                className="text-center table-secondary"
                              >
                                {item.lessons
                                  .map(
                                    (lessonItemTotal: LessonLectureStatsDto) =>
                                      lessonItemTotal.lecturesCount,
                                  )
                                  .reduce((accumulator, currentValue) => {
                                    return accumulator + currentValue;
                                  }, 0)}
                              </th>
                              <th
                                scope="col"
                                className="text-center table-secondary"
                              >
                                {t("lessons")} &nbsp;
                                <i className="ri-arrow-down-line align-bottom"></i>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {item.lessons.map((lessonItem, lessonKey) => (
                              <tr key={lessonKey}>
                                <td className="fw-medium text-center table-secondary cursor-pointer">
                                  <NavLink
                                    title={t("viewLectures")}
                                    to={`${lessonItem.id}`}
                                  >
                                    <i className="ri-book-line d-inline-block d-md-none"></i>
                                    <span className="d-none d-md-inline-block">
                                      {t("viewLectures")}
                                    </span>
                                  </NavLink>
                                </td>
                                <td className="fw-medium text-center">
                                  {lessonItem.lecturesCount}
                                </td>
                                <td className="fw-medium">
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    <span>
                                      {i18n.language === "ar"
                                        ? lessonItem.name.ar
                                        : lessonItem.name.en}
                                    </span>
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </div>
                    </Row>
                  </CardBody>
                </Card>
              </div>
            ))}
        </div>
      )}
    </Container>
  );
};
